<template>
  <div :id="renderTo" />
</template>

<script>
import Highcharts from 'highcharts';

export default {
  props: {
    chartName: {
      type: String,
      default: () => '',
    },
    apiParams: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      renderTo: _.times(10, () => _.random(35).toString(36)).join(''),
      chart: null,
      chartData: null,
      chartOptions: [],
    };
  },

  mounted() {
    this.loadChartData();

    Bus.$on('refresh', () => {
      this.loadChartData();
    });
  },

  beforeDestroy() {
    Bus.$off('refresh');
  },

  methods: {
    loadChartData() {
      axios
        .get(`/api/admin/charts/${this.chartName}`, {
          params: this.apiParams,
        })
        .then((response) => {
          this.chartData = response.data;
          this.setChartData();
        });
    },

    setChartData() {
      this.chartOptions = this.chartData.options;

      this.chartOptions.title.text = _.capitalize(this.chartOptions.title.text);

      this.chartOptions.chart = {
        renderTo: this.renderTo,
        height: 400,
      };

      this.chartOptions.xAxis = {
        categories: this.chartData.labels,
      };
      this.chartOptions.series = JSON.parse(this.chartData.datasets);

      this.chart = new Highcharts.Chart(this.chartOptions);
    },
  },
};
</script>
